export function formatFullNameInitials(fullName: string): string {
  const parts = fullName.toUpperCase().trim().split(/\s+/).filter(Boolean)
  if (parts.length == 0) {
    return ''
  } else if (parts.length == 1) {
    return parts[0][0] || ''
  } else {
    return parts[0][0] + parts[parts.length - 1][0]
  }
}

/** Browser equivalent of Ex.HumanName extraction; the suggested names remain editable. */
export function extractNameParts(fullName: string): { firstName: string; lastName: string } {
  const parts = fullName.trim().split(/\s+/)
  const normalize = (part: string) => part.replace(/\.$/, '').toLowerCase()
  const firstParts = [...parts]
  const lastParts = [...parts]
  if (
    [
      'mr',
      'mrs',
      'ms',
      'miss',
      'dr',
      'prof',
      'sir',
      'madam',
      'dame',
      'lord',
      'lady',
      'hon',
      'rev',
      'fr',
      'br',
      'sr',
      'rabbi',
      'imam',
      'sheikh',
      'sheikh',
      'shaikh'
    ].includes(normalize(firstParts[0]))
  )
    firstParts.shift()
  if (
    [
      'jr',
      'sr',
      'ii',
      'iii',
      'iv',
      'v',
      'esq',
      'md',
      'phd',
      'jd',
      'dds',
      'dmd',
      'do',
      'rn',
      'mba',
      'cpa',
      'sj',
      'op',
      'ofm',
      'osb',
      'ocd'
    ].includes(normalize(lastParts[lastParts.length - 1]))
  )
    lastParts.pop()
  let lastName = ''
  if (lastParts.length > 1) lastName = lastParts[lastParts.length - 1]
  return { firstName: firstParts.slice(0, 1).join(''), lastName }
}
